import { render } from "./UserMgmtPage.vue?vue&type=template&id=c112052c&scoped=true"
import script from "./UserMgmtPage.vue?vue&type=script&lang=js"
export * from "./UserMgmtPage.vue?vue&type=script&lang=js"

import "./UserMgmtPage.vue?vue&type=style&index=0&id=c112052c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c112052c"]])

export default __exports__